import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress' // 路由切换进度条
import 'nprogress/nprogress.css'// nprogress样式文件
import routes from './routes'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import store from '../store'
import queryString from 'query-string'
import { isMobile } from '@/utils/util'

import { switchTeam, teamListSelect } from '@/api/teamManagement'

Vue.use(VueRouter)

const allowList = ['Login', 'Register', 'ResetPassword', 'Share', 'MapComponent', 'Template', 'CanvasShare', 'joinTeam'] // no redirect allowList
const mobileList = ['Mobile', 'Share', 'Template', 'CanvasShare', 'MapComponent']
const loginRoutePath = '/login'
const mobileRoutePath = '/mobile'
const defaultRoutePath = '/controlPlatform' // 修改默认路由需要修改此处、routerUtil的rootRouter、login的loginSuccess

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

// 创建者解散团队时, 如果其他成员正在查看该团队则刷新后默认查看团队列表第一个 以及 两个不同浏览器登,录部门数据错乱问题以info的id为主
function getTeamListSelect () {
  teamListSelect().then(async (res) => {
    if (res.code === 200) {
      let tempId = Number(localStorage.getItem('teamId'))
      let includeTempId = false
      if (tempId) {
        const { data } = await store.dispatch('GetInfo')
        const extention = data.extentions.find(item => { return item.value === 'teamId' })
        if (extention) {
          tempId = Number(extention.value)
        }
        res.data.forEach((v) => {
          if (v.id === tempId) {
            includeTempId = true
            switchTeam({ teamId: tempId })
            localStorage.setItem('teamId', tempId)
          }
        })
      }
      if (!includeTempId) {
        if (tempId) localStorage.removeItem('teamId')
        localStorage.setItem('teamId', res.data[0].id)
        switchTeam({ teamId: res.data[0].id })
      }
    }
  })
}

router.beforeEach((to, from, next) => {
  // 开始进度条
  NProgress.start()
  // to.meta && (typeof to.meta.title !== 'undefined' && setDocumentTitle(`${i18nRender(to.meta.title)} - ${domTitle}`))
  /* has token */
  if (getToken()) {
    /* has token */
    if (to.name === 'MapManagement' || to.name === 'Tile' || to.name === 'Region' || to.name === 'DemandManagement' || to.name === 'DataManagement' || to.name === 'CanvasManagement') {
      getTeamListSelect()
    }
    if (to.path === loginRoutePath) {
      next({ path: defaultRoutePath })
      NProgress.done()
    } else {
      if (!store.getters.nickname || store.getters.nickname.length === 0) {
        store.dispatch('GetInfo')
          .then(() => {
            next()
          })
          .catch(() => {
            Message.error('请求用户信息失败，请重试')
            store.dispatch('Logout').then(() => {
              next({ path: loginRoutePath, query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    next()
    const shareFn = function () {
      const { query } = queryString.parseUrl(window.location.href)
      return query.share || query.templateShare
    }
    if (isMobile()) {
      if (mobileList.includes(to.name) || shareFn()) {
        next()
      } else {
        next({ path: mobileRoutePath })
      }
    } else {
      if (allowList.includes(to.name)) {
        // 在免登录白名单，直接进入
        next()
      } else if (shareFn()) {
        // 如果是分享状态下，直接进入
        next()
      } else {
        next({ path: loginRoutePath, query: { redirect: to.fullPath } })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  }
})

router.afterEach(to => {
  window.document.title = `${to.meta.title ? to.meta.title : to.name}-Shine Meta`
  // 关闭进度条
  NProgress.done()
})
export default router
